import request from '@/utils/request'

// 获取分页列表
export function getList(data) {
  return request({
    url: '/api/v1/server-group/message/pc/todoPageList',
    method: 'post',
    data
  })
}

// 待办APP获取分组----旧
export function getGroupList(data) {
  return request({
    url: '/api/v1/server-group/message/pc/todoAppGroup',
    method: 'post',
    data
  })
}
// 【查询】（PC）查询各应用下的待办数量
export function todoSAelectUnProcessCount(data) {
  return request({
    url: '/api/message/msg/message/info/sdb/todo/pt/pc/selectUnProcessCount',
    method: 'post',
    data
  })
}
// 【查询】（PC）查询各应用下的待办数量
export function pendingMessageSelectUnProcessCount(data) {
  return request({
    url: '/api/message/msg/message/info/sdb/pendingMessage/pt/pc/selectUnProcessCount',
    method: 'post',
    data
  })
}
// 【操作】变更已读
export function getDoneToRead(data) {
  return request({
    url: '/api/message/message/doneToRead',
    method: 'post',
    data
  })
}
// 待办【操作】（PC）批量修改阅读状态
export function todoUpdateBatchReadStatus(data) {
  return request({
    url: '/api/message/msg/message/info/sdb/todo/pt/pc/updateBatchReadStatus',
    method: 'post',
    data
  })
}

// 待阅 【操作】（PC）批量修改阅读状态
export function messageUpdateBatchReadStatus(data) {
  return request({
    url: '/api/message/msg/message/info/sdb/pendingMessage/pt/pc/updateBatchReadStatus',
    method: 'post',
    data
  })
}
